import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Container from "../Common/Container";
export default function ArtistProfileHero({ info }) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: false,
  };

  const shareLink = async () => {
    let shareData = {
      url: window.location.href,
    };
    if (navigator && navigator.share) {
      await navigator.share(shareData);
    }
  };

  return (
    <div id="artist-profile-slider" className=" -mt-[124px] lg:mt-0 relative  ">
      <div className="artist-profile-slider-container min-h-[210px] lg:min-h-fit relative">
        <div className=" relative lg:hidden z-[-99] ">
          <Slider {...settings}>
            <div className="  ">
              <img
                className="w-full h-full max-h-[328px] min-h-[328px] blur-md lg:aspect-[2.22/1] object-top object-cover "
                src={info?.data?.profile}
                alt=""
              />
            </div>
          </Slider>
        </div>
        <div className="absolute  bottom-0 left-0 w-full  z-[99] ">
          <Container className="lg:flex hidden justify-end lg:py-[64px] lg:px-[87.5px]">
            <button
              onClick={shareLink}
              className="flex items-center gap-[10px] px-6 py-3 border border-white rounded-[10px] "
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.18387 13.3419C9.38616 12.9381 9.5 12.4824 9.5 12C9.5 11.5176 9.38616 11.0619 9.18387 10.6581M9.18387 13.3419C8.69134 14.3251 7.67449 15 6.5 15C4.84315 15 3.5 13.6569 3.5 12C3.5 10.3431 4.84315 9 6.5 9C7.67449 9 8.69134 9.67492 9.18387 10.6581M9.18387 13.3419L15.8161 16.6581M9.18387 10.6581L15.8161 7.34193M15.8161 7.34193C16.3087 8.32508 17.3255 9 18.5 9C20.1569 9 21.5 7.65685 21.5 6C21.5 4.34315 20.1569 3 18.5 3C16.8431 3 15.5 4.34315 15.5 6C15.5 6.48237 15.6138 6.93815 15.8161 7.34193ZM15.8161 16.6581C15.6138 17.0619 15.5 17.5176 15.5 18C15.5 19.6569 16.8431 21 18.5 21C20.1569 21 21.5 19.6569 21.5 18C21.5 16.3431 20.1569 15 18.5 15C17.3255 15 16.3087 15.6749 15.8161 16.6581Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className=" lg:text-[14px] font-[700] leading-[22px]  mb-0 ">
                Share
              </p>
            </button>
          </Container>

          <Container className="lg:hidden pb-[22px] w-full  px-6  flex gap-6 items-start ">
            <img
              src={info.data?.profile}
              className="max-h-[80px] max-w-[80px]   min-w-[80px] min-h-[80px] object-cover rounded-full"
              alt=""
            />
            <div>
              <p className=" mb-0 text-xl font-[700] leading-[28px]  ">
                {info?.data?.name}
              </p>
              <div className="flex items-center gap-[9px] ">
                <p>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.24707 10.5887C3.24707 6.19221 6.81278 2.63867 11.1259 2.63867C15.4511 2.63867 19.0168 6.19221 19.0168 10.5887C19.0168 12.8042 18.2348 14.861 16.9477 16.6043C15.5278 18.5273 13.7777 20.2028 11.8078 21.5179C11.3569 21.8219 10.95 21.8448 10.4552 21.5179C8.47403 20.2028 6.72391 18.5273 5.31615 16.6043C4.02812 14.861 3.24707 12.8042 3.24707 10.5887ZM8.52922 10.8363C8.52922 12.3091 9.69565 13.4675 11.1259 13.4675C12.557 13.4675 13.7347 12.3091 13.7347 10.8363C13.7347 9.37492 12.557 8.16014 11.1259 8.16014C9.69565 8.16014 8.52922 9.37492 8.52922 10.8363Z"
                      fill="#FAFAFA"
                    />
                  </svg>
                </p>
                <p className="   mb-0 text-[#979797] ml-1 text-xs leading-[17px] ">
                  {info?.data?.city}, {info?.data?.state}
                </p>
              </div>
              <div
                className={`flex items-center gap-[9px] ${
                  !info?.data.account_type ? "hidden" : ""
                } `}
              >
                <p>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.294 15.2718H10.9696C8.74019 15.2718 6.93309 13.4322 6.93309 11.1647V6.74578C6.93309 4.47736 8.74019 2.63867 10.9696 2.63867H11.294C13.5235 2.63867 15.3315 4.47736 15.3315 6.74578V11.1647C15.3315 13.4322 13.5235 15.2718 11.294 15.2718ZM17.2196 11.0333C17.2196 10.5277 17.6222 10.119 18.1182 10.119C18.6142 10.119 19.0168 10.5277 19.0168 11.0333C19.0168 15.1468 15.9561 18.5435 12.031 18.9997V20.8402C12.031 21.3449 11.6284 21.7546 11.1324 21.7546C10.6355 21.7546 10.2338 21.3449 10.2338 20.8402V18.9997C6.30774 18.5435 3.24707 15.1468 3.24707 11.0333C3.24707 10.5277 3.64965 10.119 4.14568 10.119C4.64172 10.119 5.04429 10.5277 5.04429 11.0333C5.04429 14.4483 7.77518 17.2269 11.1324 17.2269C14.4887 17.2269 17.2196 14.4483 17.2196 11.0333Z"
                      fill="white"
                    />
                  </svg>
                </p>
                <p className=" mb-0 text-[#979797] ml-1 text-xs leading-[17px]  ">
                  {info?.data?.account_type?.replace(",", ", ")}
                </p>
              </div>
              <div
                className={`flex items-center gap-[9px] ${
                  !info?.data?.genre && "hidden"
                } `}
              >
                <p>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4116 8.81782C16.2229 10.6841 16.2229 13.71 14.4116 15.5763M17.0353 6.11436C20.2957 9.47371 20.2957 14.9203 17.0353 18.2796M5.18186 15.0645H3.71083C3.19852 15.0645 2.7832 14.6366 2.7832 14.1087V10.2855C2.7832 9.75764 3.19852 9.32972 3.71083 9.32972H5.18186L9.54832 4.83069C10.1327 4.22857 11.1319 4.65502 11.1319 5.50654V18.8877C11.1319 19.7392 10.1327 20.1656 9.54832 19.5635L5.18186 15.0645Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </p>
                <p className=" mb-0 text-[#979797] ml-1 text-xs leading-[17px] ">
                  {info?.data?.genre}
                </p>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
}
